import type { PermissionData } from "entities/permissions/types";

export enum PermissionsType {
  FETCH_FULFILLED = "entities/USER_FETCH_PERMISSIONS_SUCCESS",
}

export type FetchPermissionsFulfilledAction = { payload: PermissionData; type: PermissionsType.FETCH_FULFILLED };

export type FetchPermissionAction = FetchPermissionsFulfilledAction;
